import 'css-chunksrc/client/scenes/transferProjectResourceAllocations/resource/styles.scss';export default {
  "resource": "_resource_1u76v_1",
  "user": "_user_1u76v_8",
  "avatar": "_avatar_1u76v_20",
  "name": "_name_1u76v_30",
  "title": "_title_1u76v_35"
};